module.exports = __webpack_public_path__ + "img/left-eye.d1378721.svg";